module.exports = __webpack_public_path__ + "img/3.ece8d73f.png";